import { isObject } from "@mcwd/typescript-type-guards";


export function hasProp (obj: unknown, prop: PropertyKey)
{
  if (obj == null){
    return false;
  }
  if (isObject(obj)) {
    return Reflect.has(obj, prop);
  }
  return Reflect.has(Object(obj), prop);
}
